<script lang="ts">
  import { Icon } from '$shared/components';
  import { IconType } from '$shared/constants/IconType';

  interface Props {
    list?: CommonList[];
    onclose?: (item: CommonList) => void;
  }

  let { list = [], onclose }: Props = $props();
</script>

<div class="comp-floating-list">
  {#each list as item}
    <div class="floating-filter-i">
      <div class="filter-value">
        <div class="label">{item.label}</div>
        <Icon
          name="closeModal"
          value="icon-x white"
          type={IconType.Button}
          onclick={() => onclose?.(item)}
        />
      </div>
    </div>
  {/each}
</div>

<style>
  .comp-floating-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
  }
  .floating-filter-i {
    padding: 4px;
    border-radius: 4px;
    border: 1px solid var(--blue);
    background-color: var(--blue);
    color: white;
  }
  .filter-value {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>
